import { toast, ToastOptions } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

type ToastType = 'success' | 'warning' | 'error';
type ToastTheme = 'light' | 'dark';

export const ToastConfig = (
  message: string,
  type: ToastType = 'success', // Add default value
  theme: ToastTheme = 'light', // Add default value
) => {
  const options: ToastOptions = {
    position: 'top-center',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    theme: theme,
  };

  switch (type) {
    case 'success':
      return toast.success(message, options);
    case 'warning':
      return toast.warning(message, options);
    case 'error':
      return toast.error(message, options);
    default:
      return toast(message, options);
  }
};
